import { useState, useRef } from 'react'
import Box from '@mui/material/Box'
import styled from '@emotion/styled'

import { headerHeight, indexPageMaxContentWidth } from 'config/theme'
import NavGridText from 'components/common/GridItemWrapper/Desktop/NavGridText'
import NavGridImage from 'components/common/GridItemWrapper/Desktop/NavGridImage'

const NavPanel = styled(Box)`
  ${({ theme, $hovered }) => `
    position: fixed;
    left: 0;
    right: 0;
    top: ${headerHeight};
    max-width: ${indexPageMaxContentWidth};
    margin: 0 36px;
    height: calc(100vw * 0.35);
    background-color: rgba(251, 251, 251);
    border: 1px solid ${theme.palette.grey.secondary};
    box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.05), 0px 2px 4px rgba(0, 0, 0, 0.1);
    border-radius: 24px;
    z-index: 50;
    opacity: ${$hovered ? 1 : 0};
    transition: all .2s linear;
    pointer-events: ${$hovered ? 'default' : 'none'};
    display: flex;
    padding: 24px 16px;

    ${theme.breakpoints.up('xl')} {
      margin: 0 auto;
    }
  `}
`

const LeftPanel = styled(Box)`
  ${({ theme }) => `
    width: 32%;
    flex-shrink: 0;
    overflow-y: auto;

    ${theme.breakpoints.up('lg')} {
      width: 270px;
    }
  `}
`

const RightPanel = styled(Box)`
  ${({ theme }) => `
    flex-grow: 1;
    border-left: 1px solid ${theme.palette.grey.secondary};
    overflow-y: auto;
  `}
`

// 用物件樣式而非樣板字串的寫法是因為要使用不同字體
const SubMenuTab = styled(Box)(({ theme, $isActive }) => ({
  minHeight: '48px',
  display: 'flex',
  alignItems: 'center',
  padding: '12px 24px',
  cursor: 'pointer',
  borderRadius: '6px',
  backgroundColor: $isActive ? theme.palette.grey.third : 'transparent',
  ...($isActive
    ? theme.typography.paraTitleSmall
    : theme.typography.paraBodyMedium),

  '&:hover': {
    backgroundColor: theme.palette.grey.third,
    ...theme.typography.paraTitleSmall,
  },
  lineHeight: '140%',
}))

const NavPanelWithTab = ({
  navContent,
  hasSubMenu,
  onLinkClick,
  onCatalogOrSubMenuClick,
  onServiceClassificationClick,
  isTextMode,
  $hovered,
}) => {
  const subMenus = navContent?.subMenus
  if (Array.isArray(subMenus)) {
    subMenus.sort((a, b) => {
      if (b.sort !== a.sort) {
        return b.sort - a.sort
      }
      return new Date(b.createdAt) - new Date(a.createdAt)
    })
  }

  const [activeSubMenuIndex, setActiveSubMenuIndex] = useState(0)
  const activeSubMenu = subMenus[activeSubMenuIndex]

  const subMenuTabRefs = useRef([])

  return (
    <NavPanel $hovered={$hovered}>
      <LeftPanel>
        {subMenus.map((subMenu, index) => (
          <SubMenuTab
            key={subMenu.name}
            ref={(el) => (subMenuTabRefs.current[index] = el)}
            $isActive={activeSubMenuIndex === index}
            onMouseEnter={() => setActiveSubMenuIndex(index)}
          >
            {subMenu.name}
          </SubMenuTab>
        ))}
      </LeftPanel>
      <RightPanel>
        <Box mb={12} px={9}>
          {isTextMode ? (
            <NavGridText
              content={activeSubMenu}
              menuDataForGa={{ name: navContent.name, _id: navContent?._id }}
              hasSubMenu={hasSubMenu}
              onLinkClick={onLinkClick}
              onCatalogOrSubMenuClick={onCatalogOrSubMenuClick}
              onServiceClassificationClick={onServiceClassificationClick}
            />
          ) : (
            <NavGridImage
              content={activeSubMenu}
              menuDataForGa={{ name: navContent.name, _id: navContent?._id }}
              hasSubMenu={hasSubMenu}
              onLinkClick={onLinkClick}
              onCatalogOrSubMenuClick={onCatalogOrSubMenuClick}
              onServiceClassificationClick={onServiceClassificationClick}
            />
          )}
        </Box>
      </RightPanel>
    </NavPanel>
  )
}

export default NavPanelWithTab
